import React, { PureComponent } from 'react';

import BlurModal from '../../common/blur-modal';
import { createContainer } from '@dbk-legacy/muster/react';
import config from '../../../data/get-settings';

class InternetCheck extends PureComponent {

  render() {
    const isEnable = config.defaultEnvironment == 'static' ? false : true ;
    const {
      i18n: { messages }
    } = this.props;

    if (isEnable){

      return (
        <BlurModal
          visible={!this.props.screen.online}
          doneVisible={false}
          title={messages['app.common.copyrightText']}
          disableDone={true}
          >

          <div className="margin-right-5 margin-left-5">
            <div className="row">
              <div className="small-12 columns text-center">
                <div className="internet-connection-error">
                  {messages['app.internet.checkConnection']}
                 </div>
              </div>
            </div>
          </div>
        </BlurModal>
      );

    }
    else {
      return null;

    }

  }
}

export default createContainer({
  $queries: {
    screen:{
      online:true
    },
    i18n: {
      messages: true,
    }

  },
})(InternetCheck);



